import React from "react";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaTiktok } from "react-icons/fa6";

import { Link } from "react-router-dom";

const FooterSocialCard = ({ data }) => {
  return (
    <div className="flex items-center gap-4 border-[1px] border-white p-4 rounded-md w-[250px]">
      {/* Icons */}
      <div className="flex flex-col items-center  gap-2">
        <Link to={data.socialMedia.fb} target="_blank" className="group">
          <FaFacebook className={"w-6 h-6 group-hover:text-red-600"} />
        </Link>

        <Link to={data.socialMedia.insta} target="_blank" className="group">
          <FaInstagram className={"w-7 h-7 group-hover:text-red-600"} />
        </Link>

        <Link to={data.socialMedia.tiktok} target="_blank" className="group">
          <FaTiktok className={"w-6 h-6 group-hover:text-red-600"} />
        </Link>
      </div>
      {/* Description */}
      <div className="flex flex-col gap-2 pr-2">
        <h4 className="text-lg font-bold">{data.city}</h4>
        <p className="text-lg">{data.street}</p>
        <p className="text-lg">{data.tel}</p>
      </div>
    </div>
  );
};

export default FooterSocialCard;
